// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ij-0";
export var fileList = "_ij-2";
export var removeFileButton = "_ij-1";